import * as teams from '@microsoft/teams-js';
import { useEffect } from 'react';

const BotTeamsAppAuthProvider = () => {
  useEffect(() => {
    InitializeBotAppAuthProvider();
  }, []);

  const InitializeBotAppAuthProvider = async () => {
    await teams.app.initialize();
    teams.authentication.authenticate({
      url: `${window.location.origin}/botstart`,
      width: 600,
      height: 535,
      successCallback: (result: any) => {
        try {
          const data = JSON.parse(result);
          teams.tasks.submitTask(data);
        } catch {
          teams.tasks.submitTask({ result });
        }
      },
      failureCallback: (reason: any) => {
        console.error('AUTH FAILED:', reason);
        teams.tasks.submitTask({ err: reason });
      },
    });
  };
  return <div>Starting login…</div>;
};

export default BotTeamsAppAuthProvider;
